import { render, staticRenderFns } from "./CriteriaWithEvidencesModal.vue?vue&type=template&id=58b28630&"
import script from "./CriteriaWithEvidencesModal.vue?vue&type=script&lang=js&"
export * from "./CriteriaWithEvidencesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports